
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';

/**
 * SymbolProfitLossMultipleInfoUnsubscribeResponse struct
 */
class SymbolProfitLossMultipleInfoUnsubscribeResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!Set=} symbols
   * @constructor
   */
  constructor (parent = new Response(), symbols = new Set()) {
    super()
    super.copy(parent)
    this.Symbols = symbols
  }

  /**
   * Copy struct (shallow copy)
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @param {!SymbolProfitLossMultipleInfoUnsubscribeResponse} other Other struct
   * @returns {!SymbolProfitLossMultipleInfoUnsubscribeResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Symbols != null) {
      this.Symbols = new Set()
      for (let item of other.Symbols) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.Symbols.add(tempItem)
        } else {
          this.Symbols.add(null)
        }
      }
    } else {
      this.Symbols = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @returns {!SymbolProfitLossMultipleInfoUnsubscribeResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new SymbolProfitLossMultipleInfoUnsubscribeResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new SymbolProfitLossMultipleInfoUnsubscribeResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @param {!SymbolProfitLossMultipleInfoUnsubscribeResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SymbolProfitLossMultipleInfoUnsubscribeResponse)) {
      throw new TypeError('Instance of SymbolProfitLossMultipleInfoUnsubscribeResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Symbols: ((this.Symbols != null) ? Array.from(this.Symbols, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return SymbolProfitLossMultipleInfoUnsubscribeResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!SymbolProfitLossMultipleInfoUnsubscribeResponse} other Object value
   * @returns {!SymbolProfitLossMultipleInfoUnsubscribeResponse} Created struct
   */
  static fromObject (other) {
    return new SymbolProfitLossMultipleInfoUnsubscribeResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return SymbolProfitLossMultipleInfoUnsubscribeResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5223
  }
}

export { SymbolProfitLossMultipleInfoUnsubscribeResponse };

/**
 * Fast Binary Encoding SymbolProfitLossMultipleInfoUnsubscribeResponse field model
 */
class FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.Symbols = new fbe.FieldModelSet(new fbe.FieldModelString(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Symbols.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Symbols.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5223
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Symbols.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Symbols.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Symbols.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @param {!SymbolProfitLossMultipleInfoUnsubscribeResponse} fbeValue Default value, defaults is new SymbolProfitLossMultipleInfoUnsubscribeResponse()
   * @returns {!SymbolProfitLossMultipleInfoUnsubscribeResponse} SymbolProfitLossMultipleInfoUnsubscribeResponse value
   */
  get (fbeValue = new SymbolProfitLossMultipleInfoUnsubscribeResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @param {!SymbolProfitLossMultipleInfoUnsubscribeResponse} fbeValue SymbolProfitLossMultipleInfoUnsubscribeResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Symbols.fbeSize) <= fbeStructSize) {
      this.Symbols.get(fbeValue.Symbols)
    } else {
      fbeValue.Symbols.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Symbols.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @param {!SymbolProfitLossMultipleInfoUnsubscribeResponse} fbeValue SymbolProfitLossMultipleInfoUnsubscribeResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse}
   * @param {SymbolProfitLossMultipleInfoUnsubscribeResponse} fbeValue SymbolProfitLossMultipleInfoUnsubscribeResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Symbols.set(fbeValue.Symbols)
  }
}

export { FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse };

/**
 * Fast Binary Encoding SymbolProfitLossMultipleInfoUnsubscribeResponse model
 */
class SymbolProfitLossMultipleInfoUnsubscribeResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse(this.buffer, 4)
  }

  /**
   * Get the SymbolProfitLossMultipleInfoUnsubscribeResponse model
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeResponseModel}
   * @returns {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse} model SymbolProfitLossMultipleInfoUnsubscribeResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return SymbolProfitLossMultipleInfoUnsubscribeResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelSymbolProfitLossMultipleInfoUnsubscribeResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeResponseModel}
   * @param {!SymbolProfitLossMultipleInfoUnsubscribeResponse} value SymbolProfitLossMultipleInfoUnsubscribeResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeResponseModel}
   * @param {!SymbolProfitLossMultipleInfoUnsubscribeResponse} value SymbolProfitLossMultipleInfoUnsubscribeResponse value, defaults is new SymbolProfitLossMultipleInfoUnsubscribeResponse()
   * @return {!object} Deserialized SymbolProfitLossMultipleInfoUnsubscribeResponse value and its size
   */
  deserialize (value = new SymbolProfitLossMultipleInfoUnsubscribeResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new SymbolProfitLossMultipleInfoUnsubscribeResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new SymbolProfitLossMultipleInfoUnsubscribeResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeResponseModel}
   * @param {!number} prev Previous SymbolProfitLossMultipleInfoUnsubscribeResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { SymbolProfitLossMultipleInfoUnsubscribeResponseModel };
